/* eslint-disable filenames/match-regex */
export enum ThemeStyle {
  MODERN = 'modern',
  STANDARD = 'standard',
}

export enum ThemeStyleRadius {
  MODERN = 30,
  STANDARD = 16,
}

export enum ThemeMode {
  LIGHT = 'light',
  DARK = 'dark',
}

export enum LayoutType {
  FULL_WIDTH = 'full-width',
  BOXED = 'boxed',
  FRAMED = 'framed',
}

export enum MenuStyle {
  DEFAULT = 'default',
  STANDARD = 'standard',
  ROUNDED = 'rounded',
  ROUNDED_REVERSE = 'rounded-reverse',
  CURVED_MENU = 'curved-menu',
}

export enum LayoutDirection {
  RTL = 'rtl',
  LTR = 'ltr',
}

export enum NavStyle {
  DEFAULT = 'default',
  BIT_BUCKET = 'bit_bucket',
  STANDARD = 'standard',
  DRAWER = 'drawer',
  MINI = 'mini',
  MINI_SIDEBAR_TOGGLE = 'mini-sidebar-toggle',
  HEADER_USER = 'user-header',
  HEADER_USER_MINI = 'user-mini-header',
  H_DEFAULT = 'h-default',
  HOR_HEADER_FIXED = 'hor-header-fixed',
  HOR_DARK_LAYOUT = 'hor-dark-layout',
}

export enum FooterType {
  FIXED = 'fixed',
  FLUID = 'fluid',
}

export enum HeaderType {
  FLUID = 'fluid',
  FIXED = 'fixed',
}

export enum RouteTransition {
  NONE = 'none',
  SLIDE_LEFT = 'slideLeft',
  SLIDE_RIGHT = 'slideRight',
  SLIDE_UP = 'slideUp',
  SLIDE_DOWN = 'slideDown',
}

export enum Fonts {
  LIGHT = '300',
  REGULAR = '400',
  MEDIUM = '500',
  SEMI_BOLD = '600',
  BOLD = '700',
}

export enum AuthType {
  FIREBASE = 'firebase',
  AWS_COGNITO = 'aws_cognito',
  AUTH0 = 'auth0',
  JWT_AUTH = 'jwt_auth',
}

export enum OrderType {
  ORDER_LIST = '1',
  VOID_ITEMS = '2'
}

export enum IsVoid {
  YES = 'Y',
  NO = 'N'
}

export enum TYPE_INPUT {
  TEXT = 'text',
  RADIO = 'radio',
  EMAIL = 'email',
  PHONE = 'phone',
  NUMBER = 'number',
  PASSWORD = 'password',
  DATE = 'date',
  TEL = 'tel'
}

export enum TYPE_CAPITALIZE {
  NONE = 'none',
  SENTENCES = 'sentences',
  WORDS = 'words',
  CHARACTERS = 'characters',
}

export enum TAB_HOME {
    PAYMENT = 2,
    TABLE = 0,
    ORDER_PAID = 1,
  }
export enum TAB_ORDER_PAID {
    MAIN = 0,
    DETAIL = 1,
  }

export enum NumberChair  {
    TOW = 1,
    FOUR = 2,
    SIX = 3,
    EIGHT = 4
 }

export enum TypePrint {
    INVOICE = 1,
    BILL = 2,
    BILL_MN = 3
}

export enum TYPE_SOURCE {
    CITY_LEDGER = 'CITY_LEDGER',
    FOC = 'FOC',
    HOC = 'HOC',
    BUILDING = 'BUILDING',
    PAYMENT_OPTION = 'PAYMENT_OPTION',
    PAYMENT_METHOD = 'PAYMENT_METHOD',
    QR_PAY = 'QR_PAY'
}

export enum TYPE_EXTEMP {
   YES = 'Y',
   NO = 'N'
}


export enum TypeSocket {
    CONNECT = 'connect',
    POS = 'pos',
    CONNECT_ERROR = 'connect_error',
    CONNECT_TIMEOUT = 'connect_timeout',
    DISCONNECT = 'disconnect'
}
